module.exports = __webpack_public_path__ + "static/media/mon_vieux_grimoire2.9924939f.webp";